import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const constantRoutes = [
    {
        path: '/',
        component: () => import('@/views/Index.vue'),
    },
    {
        path: '/home',
        component: () => import('@/components/HomePage.vue'),
    },
    {
        path: '/story',
        component: () => import('@/views/about/story.vue'),
    },
    {
        path: '/team',
        component: () => import('@/views/about/team.vue'),
    },
    {
        path: '/briefIntroduction',
        component: () => import('@/views/about/briefIntroduction.vue'),
    },
    {
        path: '/productList',
        component: () => import('@/views/productList/index'),
    },
    {
        path: '/productInfo',
        component: () => import('@/views/productList/info'),
    },
    {
        path: '/elegantDemeanour',
        component: () => import('@/views/about/elegantDemeanour'),
    },
    {
        path: '/goods',
        component: () => import('@/views/about/goods/index'),
    },
    {
        path: '/goodsInfo',
        component: () => import('@/views/about/goods/info'),
    },
    {
        path: '/company/contactus',
        component: () => import('@/views/about/company/contactUs'),
    },
    {
        path: '/company/companyIntroduce',
        component: () => import('@/views/about/company/companyIntroduce'),
    },
];

const createRouter = () =>
    new Router({
        mode: 'history', // require service support
        base: '/',
        scrollBehavior: () => ({y: 0}),
        routes: constantRoutes,
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

// 针对ElementUI导航栏中重复导航报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;
